var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJavaScript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 94,
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f7df1e",
    d: "M53 17h60v60H53z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.776 67.14l4.59-2.78c.886 1.57 1.692 2.9 3.625 2.9 1.853 0 3.02-.725 3.02-3.544v-19.17h5.638v19.25c0 5.84-3.423 8.498-8.418 8.498-4.51 0-7.13-2.336-8.458-5.155m19.938-.604l4.59-2.658c1.21 1.974 2.78 3.424 5.558 3.424 2.336 0 3.826-1.168 3.826-2.78 0-1.933-1.53-2.618-4.108-3.745l-1.41-.605c-4.068-1.73-6.766-3.906-6.766-8.498 0-4.23 3.222-7.45 8.257-7.45 3.585 0 6.162 1.25 8.015 4.51l-4.4 2.82c-.967-1.732-2.014-2.416-3.625-2.416-1.65 0-2.7 1.047-2.7 2.416 0 1.69 1.047 2.377 3.464 3.424l1.4.604c4.793 2.054 7.49 4.148 7.49 8.86 0 5.075-3.987 7.854-9.344 7.854-5.236 0-8.62-2.497-10.27-5.76",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavaScript);
export default __webpack_public_path__ + "static/media/JavaScript.377fbfa7d458bd0d924ff16614986d56.svg";
export { ForwardRef as ReactComponent };